var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation"},_vm._l((_vm.navs),function(item){return (item.meta.navigation)?_c('router-link',{key:item.name,staticClass:"navigation-item",class:{ active: _vm.active === item.name },attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.name)+" ")]):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }